import React, { useEffect, useState } from "react";
import Otp from "./phone/Otp";
import EmailLogin from "./email/EmailLogin";
import "../login/login.css";
import Verify from "./phone/Verify";
import { useLocation, useNavigate } from "react-router-dom";
import BottonToggle from "../bars/BottomToggle";
import Logo from "../../images/edayalogo.svg";
import Swiper from "../../components/swiper/Swiper";
import Logoheader from "../../components/Logoheader";
import { useSelector } from "react-redux";
import Skeleton from "../../components/skeletons/skeleton";
import { LoginPageView } from '../../utils/Analytics';

function Login() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("91");
  const [showModal, setshowModal] = useState(false);

  const skeletonLoader = useSelector((store) => store.googleLoaderCheck.loader);

  const navigate = useNavigate();
  const location = useLocation();
  const showOtpModal = (data) => {
    setPhoneNumber(data);
    if (data) {
      setshowModal(true);
    }
  };

  const closeModal = () => {
    setshowModal(false);
  };

  const redirect = () => {
    if (
      localStorage.getItem("phone_no") !== null ||
      localStorage.getItem("guest_email") !== null
    ) {
      navigate("../hotel-list");
    }
  };
 
  useEffect(() => {
    LoginPageView();
    redirect();
   }, []);
  return (
    <>
      {skeletonLoader ?  <Skeleton type="page" /> :
    <div>
      <BottonToggle login />
      <Logoheader/>
      {/* <Swiper /> */}
       
      <div className="section-wrap lg:mt-6 mt-4 pb-32">

        {!phoneNumber ? (
          <div>
            <Otp submitNumber={showOtpModal} countryCodeNo={(code)=>setCountryCode(code)}/>
            <EmailLogin  source={location?.state?.source}/>
          </div>
        ) : (
          <Verify phoneNumber={phoneNumber}  source={location?.state?.source} countryCode={countryCode}/>
        )}
      </div>
    </div>
   }
    </>
  );
}

export default Login;
